import { JobGridListDtl } from '../../interfaces/job-grid-list';

export enum ScheduledJobType {
  Export = 'Export',
  Delete = 'Delete',
  Upload = 'Upload',
  Job = 'Job',
}

export interface ScheduleJobResponse {
  jobId: string;
}

export interface ScheduledJobOptions {
  refresh?: boolean;
  jobType?: ScheduledJobType;
  modalTitle?: string;
  modalMessage?: string;
  modalSubTitle?: string;
}

export interface ScheduledJobModalDescriptor {
  subject: string;
  verb: string;
  result: string;
}

export interface ActiveScheduledJob {
  subscriptionId?: string;
  taskId?: string;
  jobId?: string;
  execStatus: string;
  execStartTs?: Date;
  execEndTs?: Date;
  options?: ScheduledJobOptions;
  jobDetails?: JobGridListDtl;
}
